import { Pipe, PipeTransform } from '@angular/core';

import { ApplicationService } from '../services/application/application.service';

@Pipe({
    name: 'DualEnrollmentProgram'
})
export class DualEnrollmentProgramPipe implements PipeTransform {
    constructor(private appService : ApplicationService) { }

    transform(programID: number) {
        if (programID == null) return '';
        if (!this.appService._DualEnrollmentPrograms || !this.appService._DualEnrollmentPrograms.length) return '';

        let program = this.appService._DualEnrollmentPrograms.find(item => {
            return item.ProgramID == programID;
        });

        return (program && program.Name) || programID;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/dualenrollmentprogram.pipe.ts